import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useHasHover from "common/helpers/useHasHover";

import type { ReactNode } from "react";

interface NavItemTooltipWrapperProps {
  isExpanded: boolean;
  navItemComponent: ReactNode;
  label: string;
}

export default function NavItemTooltipWrapper({
  isExpanded,
  navItemComponent,
  label,
}: NavItemTooltipWrapperProps) {
  const hasHover = useHasHover();

  if (hasHover) {
    return (
      <Tooltip disabled={isExpanded}>
        <TooltipTrigger asChild>{navItemComponent}</TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={8}
          className="pointer-events-none"
        >
          {label}
        </TooltipContent>
      </Tooltip>
    );
  }

  return navItemComponent;
}
